export const GET_ELIGIBILITY_OPTIONS = gql`
    query getEligibilityOptions {
        getEligibilityOptions {
            mccs {
                value
                label
            }
            terminalOffers {
                value
                label
            }
            onlineOffers {
                value
                label
            }
        }
    }
`;
